module.exports = __webpack_public_path__ + "img/lianmeng-logo.0a5d1f35.png";